// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/School/index.less
// module id = 916
// module chunks = 0